import React from 'react';
import { PopupWrapperView } from '@src/features/order/pages/orders-page/components';
import { NewPopupProps } from './types';
import { ArcStack, ArcCellInfo } from '@src/core/ui';
import { CancelNewOrderButton, ProceedButton, UpdateNewOrderButton } from '@src/features/order/pages/orders-page/actions';
import { OrderEntity, OrderStatusEnum } from '@src/features/order/entities';
import { arcDateWithTime } from '@src/core/extensions';
import OrdersMap from '@src/features/order/pages/orders-page/map';
import { ArcGoogleMap } from '@src/core/controllers';

const NewPopup: React.FC<NewPopupProps> = (props) => {
  const { order = {} as OrderEntity } = props;

  const getOrderInfo = () => {
    return {
      id: order?.id || "N/A",
      createDate: order?.createDate,
      status: order?.status || OrderStatusEnum.NEW,
      packageContent: order?.packageContent || "N/A",
      clientName: order?.clientName || "N/A",
      deliveryLocation: order?.deliveryLocation,
      drone: order?.drone,
      totalFlightTime: order?.totalFlightTime || 0,
      totalDistance: order?.totalDistance || 0,
    };
  };

  const orderInfo = getOrderInfo();

  return (
    <PopupWrapperView title={'MISSION DETAILS'}>
      <ArcStack direction='row' spacing={2} width='100%'>
        <ArcStack width='50%'>
          <ArcStack my={1} spacing={2}>
            <ArcStack direction="row" spacing={4}>
              <ArcStack spacing={2} flex={1}>
                <ArcCellInfo label="Date" textProps={{ fontWeight: 400 }}>
                  {arcDateWithTime(orderInfo.createDate?.toString() || "")}
                </ArcCellInfo>
          
                <ArcCellInfo label="Package Content" textProps={{ fontWeight: 400 }}>
                  {orderInfo.packageContent}
                </ArcCellInfo>
              </ArcStack>

              <ArcStack spacing={2} flex={1}>
                <ArcCellInfo label="Order" textProps={{ fontWeight: 400 }}>#{orderInfo.id}</ArcCellInfo>

                <ArcCellInfo label="Client Name" textProps={{ fontWeight: 400 }}>
                  {orderInfo.clientName}
                </ArcCellInfo>
              </ArcStack>
            </ArcStack>

            <ArcCellInfo label="Destination" sx={{ maxWidth: "300px", marginBottom: 1 }} textProps={{ fontWeight: 400 }}>
              {orderInfo.deliveryLocation?.address || "N/A"}
            </ArcCellInfo>
          </ArcStack>

          <ArcStack spacing={1} mt={2}>
            <ArcStack spacing={1} direction='row'>
              <CancelNewOrderButton orderId={order.id} />
              <UpdateNewOrderButton order={order} />

            </ArcStack>
            <ProceedButton order={order} />
          </ArcStack>
        </ArcStack>
        <ArcStack width='336px' borderRadius={1} sx={{ overflow: 'hidden' }}>
          <ArcGoogleMap hideToolbar hideMapControls>
            <OrdersMap />
          </ArcGoogleMap>
        </ArcStack>
      </ArcStack>
    </PopupWrapperView>
  );
};


export default NewPopup;